export const CONSUMER = 'consumer';
export const ADMIN = 'admin';
export const HR_ADMIN = 'hr_admin';
export const HEALTH_ADMIN = 'health_admin';
export const CLAIMS_AGENT = 'claims_agent';
export const SUPER_ADMIN = 'super_admin';
